import { jsx as _jsx } from "react/jsx-runtime";
import { AccordionSummary } from "@mui/material";
import { forwardRef } from "react";
export const UiAccordionSummary = forwardRef((props, ref) => _jsx(AccordionSummary, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_accordion_summary.js.map